import {  inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { EClubMemberStatus } from '@app/pages/clubs/models/club-model';
import { ClubService } from '@app/pages/clubs/services/club.service';
import { htmlUrls } from '@shared/utils/router-paths';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const clubAdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state):
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router: Router = inject(Router);
  const clubService: ClubService = inject(ClubService);

  const id = route.queryParamMap.has('clubId') ? route.queryParamMap.get('clubId')! : route.paramMap.get('id')!;

  return clubService.get(id).pipe(
    map(res => {
      const result = res?.result?.isMember && res?.result?.currentMemberStatus !== EClubMemberStatus.User;

      if (!result) {
        router.navigate([htmlUrls.club, id]);
      }

      return result!;
    })
  );
}
// @Injectable({
//   providedIn: 'root'
// })

// export class ClubAdminGuard implements CanActivate {
//   constructor(
//     private router: Router,
//     private clubService: ClubService,
//   ) { }

//   canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
//     let id = route.queryParamMap.has('clubId') ? route.queryParammap.get('clubId') : route.parammap.get('id');
//     return this.clubService.get(id)
//       .pipe(
//         map(res => {
//           const result = res?.result?.isMember && res?.result?.currentMemberStatus != EClubMemberStatus.User;

//           if (!result)
//             this.router.navigate([htmlUrls.club, id]);

//           return result;
//         })
//       )
//   }
// }
